module.exports = __webpack_public_path__ + "57bbbbf68319682f2c1a8ebd1833c9db.svg";